import type { ModuleWithProviders } from '@angular/core';

// Empty so @ngrx/store-devtools never enters a release bundle. The dev variant
// is swapped in by generate_environment when serve.sh passes --debugMode.
export const devOnlyModules: ModuleWithProviders<object>[] = [];
